/* ============================================
   LOGIN COMPONENT - Classic cPanel Style
   Secure Authentication Form
   ============================================ */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      await login(username.trim(), password);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.message || 'Authentication failed');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <main className="login-box">
        <header className="login-header">
          <img
            src="https://i.ibb.co/dskBFvr8/cpanel-new-large.webp"
            alt="cPanel Logo"
            className="brand-logo"
            draggable={false}
            onContextMenu={(e) => e.preventDefault()}
          />
        </header>

        <section className="login-body">
          {error && <div className="error-banner">{error}</div>}
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
                <input
                  type="text"
                  id="username"
                  name="username"
                  placeholder="Enter your username."
                  required
                  dir="ltr"
                  autoComplete="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={isSubmitting}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
                </svg>
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Enter your account password."
                  required
                  dir="ltr"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={isSubmitting}
                />
              </div>
            </div>

            <button type="submit" className="btn-login" disabled={isSubmitting}>
              {isSubmitting ? 'Authenticating...' : 'Log in'}
            </button>
          </form>
        </section>
      </main>

      <nav className="languages-list" aria-label="Language Selection">
        <a href="#">العربية</a> | <a href="#">English</a> | <a href="#">Deutsch</a> |{' '}
        <a href="#">español</a> | <a href="#">français</a>
      </nav>

      <footer className="footer">
        <div>Copyright© 2026 cPanel, L.L.C.</div>
        <div>
          <a href="#">Privacy Policy</a>
        </div>
      </footer>

      <style>{`
        .login-page {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          transform: scale(0.99);
          transform-origin: center center;
        }
        .login-box {
          width: 360px;
          background-color: #ffffff;
          border: 1px solid #000000;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
          border-radius: 4px;
          overflow: hidden;
        }
        .login-header {
          background-color: #f4f4f4;
          padding: 25px 20px 15px 20px;
          text-align: center;
          border-bottom: 1px solid #e0e0e0;
        }
        .brand-logo {
          max-width: 200px;
          height: auto;
          display: block;
          margin: 0 auto;
          user-select: none;
          -webkit-user-drag: none;
          pointer-events: none;
        }
        .login-body {
          padding: 25px 30px;
          background-color: #ffffff;
        }
        .error-banner {
          background: #ffe0e0;
          color: #c33;
          border: 1px solid #fcc;
          padding: 10px 12px;
          border-radius: 3px;
          font-size: 12px;
          margin-bottom: 15px;
          text-align: center;
          font-weight: bold;
        }
        .form-group {
          text-align: left;
          margin-bottom: 18px;
        }
        .form-group label {
          display: block;
          font-size: 12px;
          color: #444444;
          margin-bottom: 5px;
          font-weight: bold;
        }
        .input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }
        .input-icon {
          position: absolute;
          left: 8px;
          width: 16px;
          height: 16px;
          fill: #666666;
        }
        .input-wrapper input {
          width: 100%;
          padding: 8px 8px 8px 30px;
          border: 1px solid #a6a6a6;
          border-radius: 2px;
          font-size: 13px;
          outline: none;
          background-color: #ffffff;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }
        .input-wrapper input:focus {
          border-color: #ff6c2c;
          box-shadow: 0 0 3px rgba(255, 108, 44, 0.5);
        }
        .btn-login {
          width: 100%;
          background: linear-gradient(to bottom, #ff7a3d 0%, #e05216 100%);
          background-color: #ff6c2c;
          color: #ffffff;
          border: 1px solid #c33d06;
          border-radius: 3px;
          padding: 9px;
          font-size: 13px;
          font-weight: bold;
          text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.3);
          margin-top: 5px;
          cursor: pointer;
        }
        .btn-login:hover {
          background: linear-gradient(to bottom, #ff884d 0%, #ed5a1e 100%);
        }
        .btn-login:active {
          background: #d6470d;
        }
        .btn-login:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        .languages-list {
          margin-top: 30px;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          font-size: 11px;
          direction: ltr;
        }
        .languages-list a {
          color: #cccccc;
          text-decoration: none;
        }
        .languages-list a:hover {
          color: #ffffff;
          text-decoration: underline;
        }
        .footer {
          margin-top: 40px;
          text-align: center;
          font-size: 11px;
          color: #888888;
          direction: ltr;
        }
        .footer a {
          color: #aaaaaa;
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
}
